import { render, staticRenderFns } from "./RegistrationHistory.vue?vue&type=template&id=83aebee2&scoped=true&"
import script from "./RegistrationHistory.vue?vue&type=script&lang=js&"
export * from "./RegistrationHistory.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationHistory.vue?vue&type=style&index=0&id=83aebee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aebee2",
  null
  
)

export default component.exports